export const DEFAULT_ELEMENT = 'p';
